<template>
  <v-app>
    <v-toolbar app color=#FF3401 dark>
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="../src/assets/logo.png"
          transition="scale-transition"
          width="40"
        />
        <v-toolbar-title>User Activity</v-toolbar-title>
        <v-spacer/>
        <v-btn icon @click="logout()">
          <v-icon>mdi-logout</v-icon>
        </v-btn>
    </v-toolbar>
    <v-content>
      <div id="app" class="content">
        <router-view/>
      </div>
    </v-content>
  </v-app>
</template>

<script>

import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  name: 'App',
  methods: {
    logout() {
      firebase.auth().signOut().then(() => {
        localStorage.clear();
        this.$router.replace('/login');
      });
    },
  },
};
</script>
